import ExhibitorIndex from 'Pages/Exhibitors';
import ExhibitorShow from 'Pages/Exhibitors/show';
import AdminExhibitorIndex from 'Pages/Admin/Exhibitors';
import AdminExhibitorStore from 'Pages/Admin/Exhibitors/store';

export default [
	// Frontend
	// { path: '/exhibitors', component: ExhibitorIndex },
	// { path: '/exhibitors/:exhibitorId', component: ExhibitorShow },
	// // Admin
	// { path: '/admin/exhibitors', component: AdminExhibitorIndex, guards: ['admin'] },
	// { path: '/admin/exhibitors/store/:exhibitor?', component: AdminExhibitorStore, guards: ['admin'] },
];
